/**
 * Paint order inside the canvas's `<ReactFlow>`, lowest first. React Flow's wrapper is its own stacking
 * context (`position: relative; z-index: 0`), so these never reach the canvas header, the tools pill or a
 * floating panel, which all sit outside it.
 */
export const CANVAS_LAYERS = {
  /** React Flow's pane, which holds the panned and zoomed tiles. */
  tiles: 1,
  /** The box around several selected tiles: over the tiles it frames, under the pins. */
  selectionBounds: 2,
  /** The comment pins on the canvas: over every tile, at one size at any zoom. */
  pins: 3,
  /** The selected item's bar: over the pins, so a pin never covers its actions. */
  itemBar: 4,
} as const;

/**
 * React Flow's renderer is a stacking context at `z-index: 4` that holds both the pane and the item bar
 * (`NodeToolbar` portals into it), so nothing beside it can draw between the tiles and the bar.
 * Dropping its z-index lets the pane, the pins and the bar share the wrapper's one stacking context.
 */
export const canvasLayersSx = {
  ".react-flow__renderer": { zIndex: "auto" },
  ".react-flow__pane": { zIndex: CANVAS_LAYERS.tiles },
} as const;
